export default __webpack_public_path__ + "static/media/duracell_1225x220px.2c2cdfee.png";